import React, { useEffect, useState } from 'react';
import { getCorrCutValues, getCorrCutValueIndex } from './values';
import * as Ui from './styles';
import { Selector } from '../../components';

export default function Scores({
  dark,
  initialScore,
  onChange,
}) {
  // state
  const [selectedScoreIndex, setSelectedScoreIndex] = useState(null);

  // show score initial
  useEffect(() => {
    const index = getCorrCutValueIndex(initialScore);
    setSelectedScoreIndex(index);
  }, [initialScore]);

  function handleChange(items) {
    const index = getCorrCutValueIndex(items[0].value);
    setSelectedScoreIndex(index);
    if (onChange) onChange(items);
  }

  return (
    <Ui.Container>
      <Ui.Label>{'Nota de corte'}</Ui.Label>
      <Selector
        dark={dark}
        data={getCorrCutValues()}
        initialSelectedIndexes={[selectedScoreIndex]}
        onChange={(items) => handleChange(items)}
      />
    </Ui.Container>
  );
}
